/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-06-11 09:19:46
 * @LastEditors: linxi
 * @LastEditTime: 2021-09-10 09:17:50
 */
import React, { useEffect, useState } from "react"
import EChartsReact from "echarts-for-react"
import axios from "axios"
import * as echarts from "echarts"
export interface MapChartsProps {
  onRecord: (obj: any) => void
  mapdata: any[]
  cityCode?: number
  style?: React.CSSProperties
}

export const MapCharts: React.FC<MapChartsProps> = ({
  mapdata,
  cityCode,
  style,
  onRecord,
}) => {
  const [MapOption, setMapOption] = useState<any>()
  const [mapJson, setMapJson] = useState<any>({})
  useEffect(() => {
    if (cityCode) {
      axios.get(`/geo/${cityCode}.json`).then((res) => {
        setMapJson(res.data)
      })
    } else {
      axios.get(`/geo/330000.json`).then((res) => {
        setMapJson(res.data)
      })
    }
    // if (area === "湖州市") {
    //   axios.get("/geo/huzhou.json").then((res) => {
    //     setMapJson(res.data);
    //   });
    // } else if (area === "嘉兴市") {
    //   axios.get("/geo/jiaxing.json").then((res) => {
    //     setMapJson(res.data);
    //   });
    // } else if (area === "杭州市") {
    //   axios.get("/geo/hangzhou.json").then((res) => {
    //     setMapJson(res.data);
    //   });
    // } else if (area === "绍兴市") {
    //   axios.get("/geo/shaoxing.json").then((res) => {
    //     setMapJson(res.data);
    //   });
    // } else if (area === "宁波市") {
    //   axios.get("/geo/ningbo.json").then((res) => {
    //     setMapJson(res.data);
    //   });
    // } else if (area === "舟山市") {
    //   axios.get("/geo/zhoushan.json").then((res) => {
    //     setMapJson(res.data);
    //   });
    // } else if (area === "衢州市") {
    //   axios.get("/geo/quzhou.json").then((res) => {
    //     setMapJson(res.data);
    //   });
    // } else if (area === "金华市") {
    //   axios.get("/geo/jinhua.json").then((res) => {
    //     setMapJson(res.data);
    //   });
    // } else if (area === "台州市") {
    //   axios.get("/geo/taizhou.json").then((res) => {
    //     setMapJson(res.data);
    //   });
    // } else if (area === "丽水市") {
    //   axios.get("/geo/lishui.json").then((res) => {
    //     setMapJson(res.data);
    //   });
    // } else if (area === "温州市") {
    //   axios.get("/geo/wenzhou.json").then((res) => {
    //     setMapJson(res.data);
    //   });
    // } else {
    //   axios.get("/geo/zhejiang.json").then((res) => {
    //     setMapJson(res.data);
    //   });
    // }
  }, [cityCode])

  useEffect(() => {
    if (JSON.stringify(mapJson) !== "{}") {
      echarts.registerMap("ZJ", mapJson)
      const option = {
        tooltip: {
          trigger: "item",
          formatter: function (params: any) {
            const dataCon = params.data
            if (dataCon) {
              return `${dataCon.name}<br/>机构数：${dataCon.organizationTotal}<br/>医生数：${dataCon.doctorTotal}<br/>诊疗数：${dataCon.medicalTotal}<br/>预警数：${dataCon.cautionTotal}<br/>处置数：${dataCon.handleTotal}`
            }
          },
        },
        geo: {
          map: "ZJ",
          zoom: 1.2,
          itemStyle: {
            normal: {
              shadowOffsetX: 0,
              shadowOffsetY: 8,
              shadowColor: "rgba(0, 128, 255, 1)",
            },
          },
        },
        series: [
          {
            name: "浙江省预警监管",
            type: "map",
            zoom: 1.2,
            mapType: "ZJ", // 自定义扩展图表类型
            label: {
              normal: {
                show: true,
                color: "#fff", //每个区域文字颜色
              },
              emphasis: {
                textStyle: {
                  color: "#fff",
                },
              },
            },
            data: mapdata,
            itemStyle: {
              normal: {
                borderColor: "#00E5FF", //自定义边框色
                areaColor: "#0662F3", //自定义背景色
              },
            },
            emphasis: {
              itemStyle: {
                // shadowOffsetX: 0,
                // shadowOffsetY: -8,
                // shadowColor: "rgba(0, 128, 255, 1)",
                areaColor: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 0,
                    color: "rgba(0, 229, 255, 1)",
                  },
                  {
                    offset: 1,
                    color: "rgba(0, 128, 255, 1)",
                  },
                ]),
              },
            },
          },
        ],
      }
      setMapOption(option)
    }
  }, [mapJson, mapdata])

  return (
    <>
      {MapOption && (
        <EChartsReact
          option={MapOption}
          style={style}
          onEvents={{
            click: (e: any) => {
              onRecord(e.data)
            },
          }}
        ></EChartsReact>
      )}
    </>
  )
}
